import React from 'react';
import type { InstallationDraft } from 'types/installationPresentation';
import { LegacyCheckoutPreviewHost } from 'components/OfferingPreview/LegacyCheckoutPreviewHost';
import sampleInputs from 'data/legacyCheckoutPreviewSamples.json';
import { resolveCustomizedInstallationSample } from 'utils/installationSamplePresentation';

export function CheckoutChoicePreview({ preferences, invalidTitle, compact = false }: {
  preferences: InstallationDraft; invalidTitle: string | null; compact?: boolean;
}) {
  const sample = resolveCustomizedInstallationSample(sampleInputs[0], {
    ...preferences, cartExperience: 'checkout-plus-buttons', installationMethod: 'keep-existing',
  }, { isGreen: false, isFreeGiftEnabled: false, detailsOpen: false, hasProtectionInCart: false,
    toggleLoading: false, benefitsId: compact ? 'setup-card-benefits' : 'review-benefits', controlLayout: 'two-buttons' });
  return <div className={compact ? 'relative h-28 overflow-hidden rounded-lg bg-white' : 'rounded-xl bg-slate-50 p-4 sm:p-6'}>
    {invalidTitle !== null ? <p className="p-3 text-xs text-amber-800">Restore the pending title to see your sample.</p>
      : sample.status !== 'available' ? <p className="p-3 text-xs text-slate-600">{sample.message}</p>
        : <div ref={node => { if (node) node.setAttribute('inert', ''); }} aria-hidden={compact || undefined}
          className={compact ? 'pointer-events-none absolute left-3 right-3 top-3 origin-top-left' : 'pointer-events-none'}
          style={compact ? { width: 'calc(200% - 48px)', transform: 'scale(0.5)' } : undefined}>
          <LegacyCheckoutPreviewHost snapshot={sample.snapshot} testId={compact ? 'setup-card-renderer' : 'review-renderer'} />
        </div>}
  </div>;
}

export function AssistanceProcess({ compact = false }: { compact?: boolean }) {
  return <div className={compact ? 'rounded-lg bg-indigo-50 p-2' : 'rounded-xl bg-indigo-50 p-4 sm:p-6'}>
    <svg role="img" aria-label="Free assistance process: request help, arrange setup, verify your storefront"
      viewBox="0 0 600 112" className="h-auto w-full" fill="none">
      <path d="M152 66H250M352 66H450" stroke="#a5b4fc" strokeWidth="3" strokeDasharray="7 7" />
      {[100, 300, 500].map(x => <circle key={x} cx={x} cy="66" r="44" fill="white" />)}
      <rect x="78" y="49" width="44" height="32" rx="5" stroke="#4338ca" strokeWidth="3" />
      <path d="m80 51 20 16 20-16M278 57h44M284 57v25h32V57M278 57l7-17h30l7 17M300 40v17" stroke="#4338ca" strokeWidth="3" strokeLinecap="round" />
      <path d="m500 38 22 8v20c0 14-12 23-22 29-10-6-22-15-22-29V46l22-8Z" stroke="#4338ca" strokeWidth="3" />
      <path d="m489 66 8 8 15-18" stroke="#4338ca" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
    <ol aria-hidden="true" className="mt-2 grid grid-cols-3 gap-2 text-center text-xs font-medium text-indigo-900 sm:text-sm">
      <li>1. Request help</li><li>2. Arrange setup</li><li>3. Verify your cart</li>
    </ol>
    {!compact && <p className="mt-2 text-xs text-indigo-800">Process illustration · A request and storefront verification are separate steps.</p>}
  </div>;
}
